import { useViewport } from '@farmersdog/corgi-x';

export function useIsMobileViewport() {
  const { xs, md } = useViewport();

  const isMobile = xs && !md;

  return isMobile;
}
